import './App.css'

import React, { useCallback, useEffect } from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'

import layoutRoutes from '@Pages/index'
import Layout from '@Components/layout'
import useMainRedirect from '@Hooks/main/useMainRedirect'
import usePreload from '@Hooks/main/usePreload'
import useScrollRestore from '@Hooks/common/useScrollRestore'
import useMainHeader from '@Hooks/main/useMainHeader'
import '@defign/ui/dist/defign.css'

const Container = React.memo(function Container() {
  usePreload()
  useMainHeader()
  useScrollRestore()
  const { mainRedirect } = useMainRedirect()

  return (
    <Switch>
      {mainRedirect && <Redirect from={mainRedirect.from} to={mainRedirect.to} />}
      {layoutRoutes.map((x, i) => {
        const paths: string[] = x.routes.map(({ path }: { path: string | string[] }) => path).flat()
        return (
          <Route exact={true} path={paths} key={i}>
            {/*<Layout {...x} />*/}
            <Layout layout={x.layout} routes={x.routes} />
          </Route>
        )
      })}
    </Switch>
  )
})

const App: React.FC = () => {
  // iOS Back Forward Cache Disabled
  const handlePersisted = useCallback((event: PageTransitionEvent) => {
    if (event.persisted) {
      window.location.reload()
    }
  }, [])

  useEffect(() => {
    window.addEventListener('pageshow', handlePersisted)
  }, [])

  return (
    <>
      <BrowserRouter>
        <Container />
      </BrowserRouter>

      <div id="pvframe" style={{ display: 'none' }} />
    </>
  )
}

export default App
